@if (newAccount.registrationFinished) {
  <app-new-account-desktop-finished-state></app-new-account-desktop-finished-state>
}

@if (!newAccount.registrationFinished && !newAccount.selfRegisterActive) {
  <app-new-account-desktop-inactive-state></app-new-account-desktop-inactive-state>
}

@if (!newAccount.registrationFinished && newAccount.selfRegisterActive) {
  <app-new-account-desktop-form-state></app-new-account-desktop-form-state>
}
